import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import useStudy from "../hooks/useStudy";
import CircularProgressLoader from "@Components/CircularProgressLoader";
import { useNavigate } from "react-router-dom";
const ListStudiesPage = () => {
    const { listStudies } = useStudy();
    const navigate = useNavigate();
    const [studies, setStudies] = React.useState(null);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const fetchData = async () => {
        setLoading(true);
        try {
            const data = await listStudies();
            setStudies(data);
        }
        catch (error) {
            setError("An unexpected error occurred");
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    if (loading) {
        return (_jsx(CircularProgressLoader, {}));
    }
    if (error) {
        return (_jsx(Box, { textAlign: "center", mt: 5, children: _jsx(Typography, { variant: "h6", color: "error", children: error }) }));
    }
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h1", children: "All Studies" }), _jsx(Box, { sx: { marginTop: '30px', padding: '20px', backgroundColor: 'white', borderRadius: "20px" }, children: studies && studies.records.length > 0 ? (_jsx(_Fragment, { children: _jsx(TableContainer, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsx(TableRow, { children: studies.headers.map((header) => {
                                            if (header.id === "uuid") {
                                                return null;
                                            }
                                            else {
                                                return _jsx(TableCell, { children: header.label }, header.id);
                                            }
                                        }) }) }), _jsx(TableBody, { children: studies.records.map((study) => (_jsxs(TableRow, { hover: true, sx: { cursor: "pointer" }, onClick: () => navigate('/studies/' + study.uuid), children: [_jsx(TableCell, { children: study.name }), _jsx(TableCell, { children: study.refrac_date }), _jsx(TableCell, { children: study.created_at })] }, study.uuid))) })] }) }) })) : (_jsx(Typography, { variant: "body1", children: "No studies found" })) })] }));
};
export default ListStudiesPage;
